var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-shares-item-loader"},[_c('div',{staticClass:"market-shares-item-loader__image"}),_vm._v(" "),_c('div',{staticClass:"market-shares-item-loader__content"},[_c('div',{staticClass:"market-shares-item-loader__text"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b1ee162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content-loader/MarketSharesItemLoader.vue
// module id = cnVu
// module chunks = 0